export const getProductCardProps = ({
  productId,
  listingId,
  searchResultId,
}: {
  productId?: string;
  listingId?: string;
  searchResultId?: string;
}) => {
  return {
    "data-product-listing-result-id": listingId,
    "data-search-result-id": searchResultId,
    "data-product-id": productId,
  };
};
